import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PrimaryButton, ActionButton } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { TileHeader } from './tile-header';
import { getTileStyles as getStyles, tileStyles } from './styles';
import type { TileProps } from './types';

export function Tile(props: TileProps) {
  const {
    children,
    title,
    subtitle,
    onBack,
    onNext,
    backBtnText,
    nextBtnText,
    displayMode,
  } = props;
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classNames('goal-website-container', classes.tile, classes[`tile-${displayMode}`])}>
      <TileHeader
        title={title}
        subtitle={subtitle}
        displayMode={displayMode}
      />
      {children}
      {
        (_.isFunction(onBack) || _.isFunction(onNext)) &&
        <div className={classes.navigationButtons}>
          {_.isFunction(onBack) &&
            <ActionButton
              className="back"
              onClick={onBack}
              iconProps={{ iconName: 'Back' }}
              styles={tileStyles.back}
              color="#6068FA"
            >
              {backBtnText || i18n.getString(_TL_('Back'))}
            </ActionButton>
          }
          <PrimaryButton onClick={onNext} className="next" {...({ fontWeight: 'normal' } as object)}>
            {nextBtnText || i18n.getString(_TL_('Next'))}
          </PrimaryButton>
        </div>
      }
    </div>
  );
}

Tile.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node.isRequired,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  backBtnText: PropTypes.string,
  nextBtnText: PropTypes.string,
  displayMode: PropTypes.string,
};

Tile.defaultProps = {
  onBack: undefined,
  onNext: undefined,
  backBtnText: '',
  nextBtnText: '',
  displayMode: '',
};
